import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../store/slices/authSlice';
import { clearAuthData } from '../utils/storage';

export const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = useCallback(() => {
        // Clear auth state
        dispatch(logout());
        
        // Clear all auth and local storage data
        clearAuthData();
        
        // Smooth transition to login page
        setTimeout(() => {
            navigate('/login');
        }, 500);
    }, [dispatch, navigate]);

    return handleLogout;
};